module.exports = __webpack_public_path__ + "static/img/cm.5799ad4c.svg";